const environment = import.meta.env

const APIEndpoint = environment.VITE_API_ENDPOINT || 'http://localhost:8000'
const frontUrl = environment.VITE_FRONT_URL || 'http://localhost:8080'

const endpoints = {
  dev: APIEndpoint,
  test: 'https://api-test.imobanco.com.br',
  prod: 'https://api-prod.imobanco.com.br',
}

const frontEndVersion = environment.VITE_FRONTEND_VERSION || 'untagged'

const env = environment.MODE

const settings = {
  APPLICATION_ID: `income-web-${env}`,
  SERVICE_NAME: `income-web`,
  ENV: env,
  VERSION: frontEndVersion,
  endpoint: endpoints[env],
  FRONTEND_VERSION: frontEndVersion,
  NODE_ENV: env,
  buildInviteUrl: route => {
    const mappingURL = {
      dev: frontUrl,
      test: 'https://app-test.imobanco.com.br',
      prod: 'https://app.imobanco.com.br',
    }

    return `${mappingURL[env]}/${route}`
  },
}

settings.termoDeUsoVigente =
  'https://assets.imobanco.com.br/documentos/termo_de_uso_sistema_imobanco.pdf'
settings.pessoaPoliticamenteExposta =
  'https://assets.imobanco.com.br/documentos/pessoa_politicamente_exposta.pdf'
settings.politicaDePrivacidade =
  'https://assets.imobanco.com.br/documentos/politica_de_privacidade.pdf'
settings.codigoDeCondutaEtica =
  'https://assets.imobanco.com.br/documentos/codigo_de_conduta_etica_Imobanco.pdf'

settings.InstrucoesPlanilhas = {
  file: 'https://doc.clickup.com/9007073356/d/h/8cdu22c-5793/115c03ca42df929',
  contatos: 'https://doc.clickup.com/9007073356/d/h/8cdu22c-5793/115c03ca42df929/8cdu22c-8393',
  titulos: 'https://doc.clickup.com/9007073356/d/h/8cdu22c-5793/115c03ca42df929/8cdu22c-8413',
  pagamentos: 'https://doc.clickup.com/9007073356/d/h/8cdu22c-5793/115c03ca42df929/8cdu22c-8353',
  transferencias:
    'https://doc.clickup.com/9007073356/d/h/8cdu22c-5793/115c03ca42df929/8cdu22c-8433',
}
settings.ExemploContatos =
  'https://drive.google.com/file/d/1qHYl2QSt64jpo1yn-sinA2gt2qXoKQV3/view?usp=drive_link'
settings.ExemploTitulosECarnes =
  'https://drive.google.com/file/d/1SOad5s1GsTurCSt4PlGClLIzaiD-I4Rf/view'
settings.ExemploFolhaDePagamento =
  'https://drive.google.com/file/d/1AnI8-sa0vtPrJdBjzlxIIHxyLTMtTL6x/view'
settings.ExemploPagamentoDeContas =
  'https://t9007073356.p.clickup-attachments.com/t9007073356/8cd6d38a-cb47-452a-84fe-3d31608fde3e/Exemplo%20pagamento%20de%20contas.csv'
settings.ExemploTransferenciaBancaria =
  'https://drive.google.com/file/d/1w9h2bUKL9eXryUBCOZKsPhUjOr-rWNRK/view'

export default settings
